<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>

          <!-- <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
          ><md-icon icon="bell-fill" class="border rounded p-2">edit</md-icon></md-button>-->
          <b-navbar-brand center>Misc Sales Execution Form</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                v-if="
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                  $sessionsStorage.get('designation') == 'Admin' &&
                  miscJobDetails.allModuleId != ''
                "
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalLoc"
                >Change Location</b-button
              >
              <!-- <b-button
                size="sm"
                variant="danger"
                @click="showModalCon('SPLIT')"
                >Split Containers</b-button
              > -->
              <!-- <b-button
            v-if="$sessionsStorage.get('nameUser')=='Bhavneesh' &&
             $sessionsStorage.get('designation')=='Admin'
            "
            style="margin-left: 5px"
            size="sm"
            variant="danger"
            @click="showModalLoc"
            >Change Location</b-button
          >
              <b-button
                v-if="
                ffExoprtDetail.allModuleId != '' &&
                ffExoprtDetail.shipmentType == '1' &&
                ffExoprtDetail.newContainerFlow == '1'
              "
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalCon"
                >Change Request Panel</b-button
              > -->
              <!-- <b-button
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalCon('REMOVE')"
                >Change Container Request</b-button
              > -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <h5 class="mt-2 error" v-if="miscJobDetails.allModuleId != ''">
                JOB TYPE : {{ ShowJOB+" ("+mainSalesSeries+")" }}
              </h5>
            </div>
            <b-row>
              <b-col md="4">
                <md-layout md-flex="30">
                  <label for="clientId">Other Service Type</label>
                  <model-list-select
                    :list="OtherServicTypeList"
                    id="OtherServicType"
                    v-model="miscJobDetails.OtherServicType"
                    option-value="val"
                    option-text="type"
                    placeholder="Service Type"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.OtherServicType">{{
                    errormiscJobDetails.OtherServicType
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.OtherServicType">{{
                    OtherServicTypeError
                  }}</span> -->
                </md-layout>
              </b-col>
              <b-col md="4">
                <md-layout md-flex="30">
                  <label for="clientId">Misc Job Type</label>
                  <model-list-select
                    :list="requestTypeList"
                    id="clientNamenew"
                    v-model="miscJobDetails.jobType"
                    option-value="val"
                    option-text="type"
                    placeholder="Request Type"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.jobType">{{
                    errormiscJobDetails.jobType
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.jobType">{{
                    clientTypeError
                  }}</span> -->
                </md-layout>
              </b-col>
              <b-col md="4">
                <md-layout md-flex="30">
                  <label for="clientId">Client Type</label>
                  <model-list-select
                    :list="clientTypeList"
                    id="clientNamenew"
                    v-model="miscJobDetails.clientType"
                    option-value="val"
                    option-text="type"
                    placeholder="Client Type"
                    :isDisabled="true"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.clientType">{{
                    errormiscJobDetails.clientType
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.clientType">{{
                    clientTypeError
                  }}</span> -->
                </md-layout>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <md-layout md-flex="30">
                  <label for="transportType">Shipping Type</label>
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="miscJobDetails.shipmentType"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Shipment Type"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.shipmentType">{{
                    errormiscJobDetails.shipmentType
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.shipmentType">{{
                    shipmentTypeError
                  }}</span> -->
                </md-layout>
              </b-col>
              <b-col md="4">
                <md-layout md-flex="30">
                  <label for="transportType">Export / Import</label>
                  <model-list-select
                    :list="transportTypeList"
                    v-model="miscJobDetails.transportType"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Type"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.transportType">{{
                    errormiscJobDetails.transportType
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.transportType">{{
                    transportTypeError
                  }}</span> -->
                </md-layout>
              </b-col>
              <b-col md="4" v-if="miscJobDetails.clientType != '2'">
                <md-layout md-flex="30">
                  <label for="clientId">Client Name</label>
                  <model-list-select
                    :list="clientList"
                    id="clientNamenew"
                    v-model="miscJobDetails.clientId"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Existing Client Name"
                  ></model-list-select>
                  <span class="error" v-if="!miscJobDetails.clientId">{{
                    errormiscJobDetails.clientId
                  }}</span>
                  <!-- <span class="error" v-if="!miscJobDetails.clientId">{{
                    clientIdError
                  }}</span> -->
                </md-layout>
              </b-col>
            </b-row>
            

            <!-- <md-layout md-gutter>
              <md-layout md-flex="30">
                <label for="clientId">Other Service Type</label>
                <model-list-select
                  :list="OtherServicTypeList"
                  id="OtherServicType"
                  v-model="miscJobDetails.OtherServicType"
                  option-value="val"
                  option-text="type"
                  placeholder="Service Type"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.OtherServicType">{{
                  errormiscJobDetails.OtherServicType
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="clientId">Misc Job Type</label>
                <model-list-select
                  :list="requestTypeList"
                  id="clientNamenew"
                  v-model="miscJobDetails.jobType"
                  option-value="val"
                  option-text="type"
                  placeholder="Request Type"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.jobType">{{
                  errormiscJobDetails.jobType
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="clientId">Client Type</label>
                <model-list-select
                  :list="clientTypeList"
                  id="clientNamenew"
                  v-model="miscJobDetails.clientType"
                  option-value="val"
                  option-text="type"
                  placeholder="Client Type"
                  :isDisabled="true"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.clientType">{{
                  errormiscJobDetails.clientType
                }}</span>
              </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout> -->
              <!-- <md-layout md-flex="30">
                <label for="transportType">Shipping Type</label>
                <model-list-select
                  :list="shipmentTypeList"
                  v-model="miscJobDetails.shipmentType"
                  option-value="shipmentTypeVal"
                  option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"
                ></model-list-select>

                <span class="error" v-if="!miscJobDetails.shipmentType">{{
                  shipmentTypeError
                }}</span>
              </md-layout> -->
            <!-- </md-layout> -->
            <!-- <md-layout md-gutter>
              <md-layout md-flex="30">
                <label for="transportType">Shipping Type</label>
                <model-list-select
                  :list="shipmentTypeList"
                  v-model="miscJobDetails.shipmentType"
                  option-value="shipmentTypeVal"
                  option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.shipmentType">{{
                  errormiscJobDetails.shipmentType
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="transportType">Export / Import</label>
                <model-list-select
                  :list="transportTypeList"
                  v-model="miscJobDetails.transportType"
                  option-value="transportTypeVal"
                  option-text="transportTypeText"
                  placeholder="Select Type"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.transportType">{{
                  errormiscJobDetails.transportType
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="30" v-if="miscJobDetails.clientType != '2'">
                <label for="clientId">Client Name</label>

                <model-list-select
                  :list="clientList"
                  id="clientNamenew"
                  v-model="miscJobDetails.clientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Existing Client Name"
                ></model-list-select>
                <span class="error" v-if="!miscJobDetails.clientId">{{
                  errormiscJobDetails.clientId
                }}</span>
              </md-layout>
            </md-layout> -->

            <md-layout md-gutter class="mt-3 justify-content-center">
              <b-button
                :disabled="miscJobDetails.allModuleId != ''"
                variant="primary"
                id="addButtonLoader"
                @click="addMiscJob"
                >Save & Send To Execution</b-button
              >
              <md-spinner
                md-indeterminate
                id="loader"
                style="display: none"
              ></md-spinner>
            </md-layout>

            <md-layout md-gutter v-if="miscJobDetails.allModuleId != ''">
              <b-button
                :disabled="miscJobDetails.asignDeleted == '1'"
                class="gutr mt-2 smbutnWidth"
                variant="primary"
                id="addButtonLoader"
                @click="proceedToNext('invoice')"
                >Proceed To Invoice
              </b-button>
              <md-spinner
                md-indeterminate
                id="loader"
                style="display: none"
              ></md-spinner>
            </md-layout>

            <md-layout md-gutter v-if="miscJobDetails.allModuleId != ''">
              <!-- <b-button
                 :disabled="miscJobDetails.asignDeleted=='1'"
                  class="gutr mt-2 smbutnWidth"
                 
                  variant="primary"
                  id="addButtonLoader"
                  @click="proceedToNext('sline')"
                  >Proceed to Sline Payment </b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner> -->
              <b-button
                :disabled="miscJobDetails.asignDeleted == '1'"
                class="mt-1"
                variant="primary"
                @click="proceedToNext('sline')"
                id="addButtonLoaderVGM"
                >Save & Proceed To S-Line Payment</b-button
              >
              <md-spinner
                md-indeterminate
                id="loaderVGM"
                style="display: none"
              ></md-spinner>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <b-modal
        no-close-on-esc
        no-close-on-backdrop
        ref="location-modal"
        hide-footer
        id="modal-multi-2"
        size="lg"
        :title="'Change Location Of : ' + seriesNumber"
      >
      <div class="row">
        <div class="col-md-12">
        <model-list-select
          :list="options1"
          v-model="objectItem"
          option-value="pickupLocation"
          option-text="pickupLocation"
          placeholder="select item"
        >
        </model-list-select>
        </div>
        <div class="col-md-12  text-center">
        <b-button
          size="sm"
          class="mt-4 ml-auto"
          style="font-size: 0.675rem"
          variant="outline-success"
          @click="changeLocation"
          ><b>Save</b>
        </b-button>
        <b-button
          size="sm"
          class="mt-4"
          style="font-size: 0.675rem"
          variant="outline-danger"
          @click="hideModalLoc"
          ><b>Close</b>
        </b-button>
        </div>
        </div>
      </b-modal>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAddFF"
      ref="addPop"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="updateClientNew"
      ref="addClient"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-title="alert.title"
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="sendExecutionTeam"
      ref="sendExecution"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
//import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
// import clientForm from "../view/clients/addClient.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  beforeMount() {
    //  eventBus.$emit("formName",
    //  {
    // name:"Ajit"
    //  })
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/allModuleForm/allModuleForm");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    singleSelectContainer: {
      handler: function (newVal, oldVal) {
        let dummysplitContainerType = [];
        let dummysplitContainerTypeId = [];

        for (let p = 0; p < this.singleSelectContainer.length; p++) {
          let con = this.containerDetails.filter((y) => {
            return y.uniqueContainerId == this.singleSelectContainer[p];
          });

          if (con.length > 0) {
            dummysplitContainerType.push(con[0].containerType);
            dummysplitContainerTypeId.push(con[0].containerTypeId);
          }
        }
        if (dummysplitContainerType.length > 0) {
          this.validExecution = [];
          var count = {};
          dummysplitContainerType.forEach(function (i) {
            count[i] = (count[i] || 0) + 1;
          });
          this.splitContainerType = Object.keys(count).toString();
          this.splitContainerTypeCount = Object.values(count).toString();
          this.splitContainerTypeId = [
            ...new Set(dummysplitContainerTypeId),
          ].toString();
          let execValid = [];
          //   for (let s = 0; s < dummysplitContainerTypeId.length; s++) {
          if (this.actionType == "MERGE") {
            execValid = this.clientMergeExecutionData.filter((x) => {
              return (
                x.multipleContainerTypeId.includes(this.splitContainerTypeId) &&
                x.pickupLocationId == this.ffExoprtDetail.pickupLocationId &&
                x.stuffingLocationId ==
                  this.ffExoprtDetail.stuffingLocationId &&
                x.handoverLocationId ==
                  this.ffExoprtDetail.handoverLocationId &&
                x.PORlocationId == this.ffExoprtDetail.PORlocationId &&
                x.PODLocationId == this.ffExoprtDetail.PODLocationId &&
                x.LPlocationId == this.ffExoprtDetail.LPlocationId &&
                x.finalPlaceLocationId ==
                  this.ffExoprtDetail.finalPlaceLocationId &&
                x.shippingId == this.ffExoprtDetail.shippingId
              );
            });
          } else if (this.actionType == "MOVE") {
            execValid = this.clientMergeExecutionData.filter((x) => {
              return (
                x.multipleContainerTypeId.includes(this.splitContainerTypeId) &&
                x.pickupLocationId == this.ffExoprtDetail.pickupLocationId &&
                x.stuffingLocationId ==
                  this.ffExoprtDetail.stuffingLocationId &&
                x.handoverLocationId ==
                  this.ffExoprtDetail.handoverLocationId &&
                x.PORlocationId == this.ffExoprtDetail.PORlocationId
              );
            });
          }
          console.log(execValid, "uyiuyi");
          // }

          if (execValid.length > 0) {
            this.validExecution.push(...execValid);
          }
          console.log(this.validExecution);
        }
        console.log(this.splitContainerTypeCount);
      },

      deep: true,
    },
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        //   if(this.ffExoprtDetail.validBookingNo){
        //   let string = this.ffExoprtDetail.validBookingNo.replace(/[^a-zA-Z0-9]/g,',');
        //   this.ffExoprtDetail.validBookingNo=string.toUpperCase()
        //  console.log(this.ffExoprtDetail.validBookingNo)
        //  }
        if (this.ffExoprtDetail.PORlocationId != "") {
          let array = this.IcdPOrtList.filter((x) => {
            return x.pickupId == newVal.PORlocationId;
          })[0];

          this.ffExoprtDetail.portType = array.locationType;
          // if (array.locationType != "Icd") {
          //   this.PortLoadList = this.IcdPOrtList;
          //   this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
          // }

          // this.deliveryTermsName[1].deliveryTermsText =
          //   "FOB_POR_ " + array.mainLocation;
        }

        // if (
        //   newVal.LPlocationId != "" &&
        //   this.ffExoprtDetail.allModuleId == ""
        // ) {
        //   let array1 = this.PortLoadList.filter(x => {
        //     return x.pickupId == newVal.LPlocationId;
        //   })[0];
        //   this.deliveryTermsName[2].deliveryTermsText =
        //     "FOB_LoadPort_ " + array1.pickupLocation;
        // }

        if (
          this.ffExoprtDetail.shipmentType == "Sea_Shipment" &&
          this.ffExoprtDetail.allModuleId == ""
        ) {
          if (
            newVal.containerInfo != "fcl" &&
            this.ffExoprtDetail.allModuleId == ""
          ) {
            this.ffExoprtDetail.stuffingType = "warehouseStuffing";
          }
        }
        if (this.ffExoprtDetail.clientId != "") {
          this.factoryDetail = this.tempfactoryDetail.filter((x) => {
            return x.clientId == this.ffExoprtDetail.clientId;
          });

          if (
            this.ffExoprtDetail.transportType == "Export" &&
            this.ffExoprtDetail.clientType != "3"
          ) {
            this.ffExoprtDetail.exporterClientId = this.ffExoprtDetail.clientId;
          } else if (
            this.ffExoprtDetail.transportType == "Import" &&
            this.ffExoprtDetail.clientType != "3"
          ) {
            this.ffExoprtDetail.importerClientId = this.ffExoprtDetail.clientId;
          }
        }

        // if (this.ffExoprtDetail.commodityId != "") {
        //   let array = this.getCommodityData.filter(x => {
        //     return x.commodityId == this.ffExoprtDetail.commodityId;
        //   });
        //   this.CommodityCallback(array[0]);
        // }
        if (this.ffExoprtDetail.exporterClientId != "") {
          if (
            this.ffExoprtDetail.clientType == "3" &&
            this.newJobType.indexOf("TPT") < 0
          ) {
            this.getData("No");
          }
          let dummyExporter = this.getImporterExpo.filter((x) => {
            return x.clientId == this.ffExoprtDetail.exporterClientId;
          });
          if (dummyExporter.length > 0) {
            if (dummyExporter[0].clientName == "Others") {
              this.openExpoInput = true;
            } else {
              this.openExpoInput = false;
            }
          }
        }
        if (this.ffExoprtDetail.importerClientId != "") {
          let dummyImporter = this.getImporterExpo.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });
          if (dummyImporter.length > 0) {
            if (dummyImporter[0].clientName == "Others") {
              this.openImpoInput = true;
            } else {
              this.openImpoInput = false;
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      ON_Type: "",
      ffSlinePayId: "",
      userId: "",
      seriesNumber: "",
      allModuleId: "",
      options1: [],
      objectItem: {},
      checkstatus: "0",
      allExistingData: [],
      showSameBookingError: "",
      showFactLocError: "",
      actionType: "",
      getLocSearchResults: [],
      singleSelectContainer: [],
      splitContainerType: "",
      splitContainerTypeId: "",
      splitContainerTypeCount: "",
      factoryModal: {
        locSearch: "",
        longitude: "",
        latitude: "",
        multiFactoryId: "",
        clientId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      },
      airLineList: [],
      getColoaderNameList: [],
      containerDetails: [],
      openExpoInput: false,
      openImpoInput: false,
      isLoading: false,
      disableFactory: false,
      factoryDetail: [],
      tempfactoryDetail: [],
      execDoneData: [],
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "JobType Executed Already..! ",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      opnTPT: false,
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
        // {
        //   transportTypeVal: "Empty_Moment",
        //   transportTypeText: "Empty Moment"
        // }
      ],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory Stuffing",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse Stuffing",
        },
      ],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
        {
          containerInfoVal: "LclConsolidation",
          containerInfoText: "LCL Consolidation",
        },
      ],
      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],

      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      showAdd: false,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      allAgentColoader: [],
      ffShippingArray: [],
      CommodityAll: {},
      autoClientName: {},
      freightNoOfContainers: [],
      multiContainer: [],
      miscJobData: [],
      miscJobDetails: {
        allModuleId: "",
        jobType: "",
        clientId: "",
        clientType: "1",
        OtherServicType: "",
        shipmentType: "",
        transportType: "",
        asignDeleted: "0",
      },
      errormiscJobDetails: {
        clientType: "",
        OtherServicType: "",
        jobType: "",
        shipmentType: "",
        transportType: "",
        clientId: "",
      },
      arrayErrormiscJobDetails: [
        {
          clientType: "Please Select Client Type",
          OtherServicType: "Please Select Service Type",
          jobType: "Please Select Job Type",
          shipmentType: "Please Select Shipping Type",
          transportType: "Please Select Transport Type",
          clientId: "Please Select Client Name",
        },
      ],

      ffExoprtDetail: {
        newContainerFlow: "",
        changedRequestJobType: [],
        mergeToAssignmentId: "",
        multipleContainerTypeId: "",
        validBookingNo: "",
        mainEnquirySeries: "",
        coLoaderId: "",
        onAccountOf: "",
        freightNoOfContainers: "",
        BranchCode: "",
        multiContainer: [],
        allModuleId: "",
        mainEnquiryId: "",
        ffShippingWiseId: "",
        // tptEnquiry: [],
        // ffEnquiry: [],
        // ccEnquiry: [],
        ccType: "",
        tptType: "",
        tptClientStatus: "",
        ccClientStatus: "",
        ccCha: "",
        transporterName: "",
        allModuleId: "",
        transContainerTypeId: "",
        transContainerType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        containerId: "",
        clientId: "",
        shippingId: "",
        shipmentType: "2",
        transportType: "",
        stuffingType: "",
        containerInfo: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "",
        deliveryTerms: "",
        exporterClientId: "",
        importerClientId: "",
        //   commodityId: "",
        IMDGClass: "",
        commodityType: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        portType: "",
        jobType: [],
        noOfContainer: "",
        clientType: "1",
        OtherServicType: "",
        currencyType: "1",
        agreedByingOceanRate: "0",
        agreedSellingOceanRate: "0",
        airportDeparture: "",
        airportDestination: "",
        cargoReceived: "",
        destinationModeAir: "",
        doorDestinationfpod: "",
        estimatedDate: "",
        newClientName: "",
        newClientEmail: "",
        newClientAddress: "",
        newClientPhoneNumber: "",
        ffClientStatus: "",
        otherExpoName: "",
        otherImpoName: "",
      },
      transportTypeError: "",
      shipmentTypeError: "",
      clientIdError: "",
      clientTypeError: "",
      OtherServicTypeError: "",
      currencyTypeError: "",
      agreedByingOceanRateError: "",
      agreedSellingOceanRateError: "",
      pickupLocationIdError: "",
      stuffingLocationIdError: "",
      newClientNameError: "",
      newClientEmailError: "",
      newClientAddressError: "",
      newClientPhoneNumberError: "",
      handoverLocationIdError: "",
      //  transContainerTypeIdError: "",
      containerInfoError: "",
      shipmentTypeError: "",
      importerClientIdError: "",
      commodityTypeError: "",
      exporterClientIdError: "",
      stuffingTypeError: "",
      airportDepartureError: "",
      airportDestinationError: "",
      cargoReceivedError: "",
      destinationModeAirError: "",
      shippingIdError: "",
      PORlocationIdError: "",
      LPlocationIdError: "",
      PODLocationIdError: "",
      finalPlaceLocationIdError: "",

      deleteId: "",

      containerModal: {
        containerType: "",
        noOfContainer: "",
        containerTypeId: "",
      },
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      getImporterExpo: ["gfdg"],
      factoryDetail: [],
      destinationDelieveryList: [
        {
          type: "upto Airport",
          val: "1",
        },
        {
          type: "DOOR",
          val: "2",
        },
      ],
      cargoReceivedList: [
        {
          type: "Airport",
          val: "1",
        },
        {
          type: "Warehouse",
          val: "2",
        },
      ],
      statusModal: {
        tptClientStatus: "",
      },
      statusList: [
        // {
        //   statusV: "0",
        //   statusT: "In Progress"
        // },
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      clientMergeExecutionData: [],
      validExecution: [],
      clientTypeList: [
        {
          type: "Client",
          val: "1",
        },
        {
          type: "Lead",
          val: "2",
        },
        {
          type: "Overseas Agent",
          val: "3",
        },
      ],

      requestTypeList: [
        {
          type: "ADCode",
          val: "ADCode",
        },
        {
          type: "COC",
          val: "COC",
        },
        {
          type: "TR6 CHALLAN",
          val: "TR6 CHALLAN",
        },
        {
          type: "BOND",
          val: "BOND",
        },
        {
          type: "PLANT AND QUARANTINE",
          val: "PLANT AND QUARANTINE",
        },
        {
          type: "SAFTA",
          val: "SAFTA",
        },
        {
          type: "HEALTH",
          val: "HEALTH",
        },
        {
          type: "FSSAI NOC",
          val: "FSSAI NOC",
        },
        {
          type: "ADC NOC",
          val: "ADC NOC",
        },
        {
          type: "FACTORY STUFFING PERMISSION",
          val: "FACTORY STUFFING PERMISSION",
        },
        {
          type: "WILDLIFE NOC",
          val: "WILDLIFE NOC",
        },
        {
          type: "CA CERTIFICATE",
          val: "CA CERTIFICATE",
        },
        {
          type: "LICENSE REGISTRATION",
          val: "LICENSE REGISTRATION",
        },
        {
          type: "EGM CHARGES",
          val: "EGM CHARGES",
        },
        {
          type: "GST RETURN CHARGES",
          val: "GST RETURN CHARGES",
        },
        {
          type: "RAIL FREIGHT",
          val: "RAIL FREIGHT",
        },
        {
          type: "CONCOR CHARGES",
          val: "CONCOR CHARGES",
        },
        {
          type: "Air- Transport".toUpperCase(),
          val: "Air- Transport".toUpperCase(),
        },
        {
          type: "Air- Custom Clearance".toUpperCase(),
          val: "Air- Custom Clearance".toUpperCase(),
        },
        {
          type: "Booking Cancellation".toUpperCase(),
          val: "Booking Cancellation".toUpperCase(),
        },
        {
          type: "Pallet Charges".toUpperCase(),
          val: "Pallet Charges".toUpperCase(),
        },
        {
          type: "Back to Town".toUpperCase(),
          val: "Back to Town".toUpperCase(),
        },
        {
          type: "Miscellaneous".toUpperCase(),
          val: "Miscellaneous".toUpperCase(),
        },
        {
          type: "YARD".toUpperCase(),
          val: "YARD".toUpperCase(),
        },
        {
          type: "IB".toUpperCase(),
          val: "IB".toUpperCase(),
        },
      ],
      currencyTypeList: [
        {
          type: "USD",
          val: "1",
        },
        {
          type: "INR",
          val: "2",
        },
      ],
      OtherServicTypeList: [
        {
          type: "MISCELLANEOUS",
          val: "MISCELLANEOUS",
        },
        {
          type: "YARD",
          val: "YARD",
        },
        {
          type: "IB",
          val: "IB",
        },
      ],
      ShowJOB: "",
      mainSalesSeries:"",
      factorySelectedAtEnquiry: "",
      showSegmentArray: [],
      jobTypeFromEnquiry: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",
        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
        "Please Select Delivery  Terms",
        "Please Select Delivery Mode",
        "Please Select Exporter Name",
        "Please Select Importer Name",
        "Please Select Shipment type",
        "Please Select FF Activity",
        "Please Select Container type",
        "Please Select Handover Location",
        "Please Select Stuffing Location",
        "Please Select Pickup Location",
        "Please Select Transport Type",
        "Please Select Shipping Line",
      ],
      ffExporterrorList: {
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        //   commodityId: "",
        stuffingType: "",
        deliveryTerms: "",

        deliveryMode: "",
        exporterClientId: "",
        importerClientId: "",
        shipmentType: "",
        containerInfo: "",
        transContainerTypeId: "",
        handoverLocationId: "",
        stuffingLocationId: "",
        pickupLocationId: "",
        transportType: "",
        shippingId: "",
      },

      ContainerError: [
        "Please Select Container",
        "Please Enter No of Container",
      ],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },
      // PortDischargeList:[],
      getPortDischargeList: [],
      PortLoadList: [],
      AirPortLoadList: [],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      allModuleIdNew:
        this.$sessionsStorage.get("editallModuleId") != "" ||
        this.$sessionsStorage.get("editallModuleId") != undefined
          ? this.$sessionsStorage.get("editallModuleId")
          : "",
      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: [],
      getAlllocationListDataFactory: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],

      finalAllPlaceData: [],
      validate: true,
      miscvalidate: false,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      newJobType: [],
    };
  },

  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editSalesExId", "");
  },
  destroyed() {},
  components: {
    // clientForm,
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    DisableSubmit() {
      // if(this.newJobType.indexOf("FF") <= 0 && this.newJobType.indexOf("CC") <= 0 && this.newJobType.indexOf("TPT") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.containerInfo ||
      // !this.ffExoprtDetail.importerClientId ||
      // !this.ffExoprtDetail.exporterClientId ||
      // !this.ffExoprtDetail.stuffingType ||
      // !this.ffExoprtDetail.shippingId ||
      // !this.ffExoprtDetail.PORlocationId ||
      // !this.ffExoprtDetail.LPlocationId ||
      // !this.ffExoprtDetail.PODLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId ||
      // !this.ffExoprtDetail.pickupLocationId ||
      // !this.ffExoprtDetail.handoverLocationId ||
      // !this.ffExoprtDetail.stuffingLocationId
      // ){
      // console.log("lp")
      // return true;
      // }else{
      // return false;
      // }
      // }else if(this.newJobType.indexOf("FF") <= 0 && this.newJobType.indexOf("CC") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.containerInfo ||
      // !this.ffExoprtDetail.importerClientId ||
      // !this.ffExoprtDetail.exporterClientId ||
      // !this.ffExoprtDetail.stuffingType ||
      // !this.ffExoprtDetail.PORlocationId ||
      // !this.ffExoprtDetail.LPlocationId ||
      // !this.ffExoprtDetail.PODLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId
      // ){
      // console.log("m")
      // return true;
      // }else{
      // return false;
      // }
      // }else if(this.newJobType.indexOf("TPT") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.pickupLocationId ||
      // !this.ffExoprtDetail.handoverLocationId ||
      // !this.ffExoprtDetail.stuffingLocationId
      // ){
      // console.log("l")
      // return true;
      // }else{
      // return false;
      // }
      // }
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    transportTypeList() {
      return this.transportTypeName;
    },

    stuffingTypeList() {
      return this.stuffingTypeName;
    },

    containerInfoList() {
      return this.containerInfoName;
    },

    deliveryModeList() {
      return this.deliveryModeName;
    },

    deliveryTermsList() {
      return this.deliveryTermsName;
    },

    pdaDetailList() {
      return this.pdaDetailsName;
    },
    oceanFreightTermsList() {
      return this.oceanFreightTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    // getColoaderNameList() {
    //   return this.getColoaderName;
    // },
  },
  methods: {
    proceedToNext(type) {
      this.$sessionsStorage.set("editExportFCLId", "");
      this.$sessionsStorage.set("editFFBookingId", "");
      this.$sessionsStorage.set("ffExecutionId", "");

      if (type == "invoice") {
        let transportType = 'Export';
      if(this.mainSalesSeries){
       transportType = this.mainSalesSeries.split('/')[1];
        if(transportType=='Imp'){
          transportType='Import';
        }else if(transportType=='Exp'){
          transportType='Export';
        }else{
          transportType='Export';
        }
      }else{
        transportType='Export';
      }
        this.$router.push({
          path: "/misc/invoice?JobType="+this.ShowJOB+"&ShipmentType=Sea&ModuleType="+transportType,
        });
      } else if (type == "sline") {
        // alert(this.ON_Type);
        // alert(this.ffSlinePayId);
        if (
          (this.ON_Type == "New" && this.ffSlinePayId != "") ||
          this.ON_Type == "New" ||
          this.ffSlinePayId == "" ||
          this.ffSlinePayId == undefined
        ) {
          this.$router.push({
            path: "/misc/miscInvoiceSlinePayment_VP",
          });
        } else {
          this.$router.push({
            // path: "/misc/slinePayment",
            // path: "/misc/invoiceSlinePayment",
            path: "/misc/invoiceSlinePayment",
          });
        }
      } else if (type == "PAYTEST") {
        if (
          (this.ON_Type == "New" && this.ffSlinePayId == "") ||
          this.ffSlinePayId == undefined
        ) {
          this.$router.push({
            path: "/misc/ffSLinePaymentExportN_VP",
            // path: "/freightForward/ffSLinePaymentExportNew",
          });
        } else {
          this.$router.push({
            path: "/misc/invoiceSlinePayment",
          });
        }
      }
    },
    mergeSplitAssignmentConfirm() {
      this.$refs["my-modal-confirm"].show();
    },
    changeOnRadio() {
      this.singleSelectContainer = [];
      this.ffExoprtDetail.changedRequestJobType = [];
      if (this.ShowJOB) {
        this.ffExoprtDetail.changedRequestJobType = this.ShowJOB.split(",");
      }
    },
    showModalCon(id) {
      this.singleSelectContainer = [];
      // this.actionType = id;
      this.fetchSMData();
    },
    showModalLoc(id) {
      this.singleSelectContainer = [];
      // this.actionType = id;
      this.getLocations();
    },
    hideModalLoc() {
      this.actionType = "";
      this.$refs["location-modal"].hide();
    },
    hideModalCon() {
      this.actionType = "";
      this.$refs["my-modal-con"].hide();
    },

    hideModalConfirm() {
      this.$refs["my-modal-confirm"].hide();
    },

    fetchExistExec() {
      let new_data = {
        validBookingNo: this.ffExoprtDetail.validBookingNo,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchSameExecBookingNo.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data.status, "uy");
          if (result.data.status == "400") {
            this.showSameBookingError =
              "No Already Linked With Other Assignment";
            this.checkstatus = "0";
          } else {
            this.showSameBookingError = "";
            this.checkstatus = "0";
            console.log(this.showSameBookingError, "u");
          }
          if (result.data.allExistingData.length > 0) {
            this.allExistingData = result.data.allExistingData;
          }
        })
        .catch((error) => {});
    },
    fetchLoc() {
      let options = {
        method: "GET",
        url:
          `http://open.mapquestapi.com/nominatim/v1/search.php?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&format=json&q=city mall,andheri,india` +
          this.factoryModal.locSearch,
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data);
          // getLocSearchResults
        })
        .catch((error) => {});
    },
    fetchLatLog() {
      let options = {
        method: "GET",
        url:
          // `https://www.mapquestapi.com/geocoding/v1/address?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&location=` +
          `https://www.mapquestapi.com/geocoding/v1/address?key=AiBjJ4PC52j31H0BO1xlTTXDHIAZwDD0&location=` +
          this.factoryModal.factoryAddress1,
      };

      axios(options)
        .then((result) => {
          console.log(result.data.results[0].locations[0].displayLatLng);
          this.factoryModal.latitude =
            result.data.results[0].locations[0].displayLatLng.lat;
          this.factoryModal.longitude =
            result.data.results[0].locations[0].displayLatLng.lng;
        })
        .catch((error) => {});
    },
    addClient(id) {
      if (
        this.ffExoprtDetail.clientType == "3" &&
        this.ffExoprtDetail.transportType == "Export"
      ) {
        this.factoryModal.clientId = this.ffExoprtDetail.exporterClientId;
      } else {
        this.factoryModal.clientId = this.ffExoprtDetail.clientId;
      }

      if (
        this.factoryModal.factoryTitle == "" ||
        this.factoryModal.latitude == "" ||
        this.factoryModal.longitude == ""
      ) {
        this.showFactLocError = "Please Enter all mandatory* Fields";
        return false;
      } else {
        this.showFactLocError = "";
      }

      let new_data = {
        buttonId: "AddFactory",
        factoryModal: this.factoryModal,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addClientFactorySalesExecu.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result);
          this.getData();
          Object.keys(this.factoryModal).map((x) => {
            this.factoryModal[x] = "";
          });
          this.$refs["my-modal"].hide();
        })
        .catch((error) => {});
    },

    showModal() {
      this.$refs["my-modal"].show();
    },
    showModalExist() {
      this.$refs["my-modal-exist"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    openLocationDialog() {
      this.$refs["dialogLocation"].open();
    },
    closeModalLocation() {
      this.getData();
      this.$refs["dialogLocation"].close();
    },
    removeContainerType(index) {
      this.multiContainer.splice(index, 1);
    },

    updateClient() {
      this.alert.content =
        "Are you sure you want to convert your lead to client?";
      this.$refs["addClient"].open();
    },

    updateClientNew(type) {
      if (type != "cancel") {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/updateClient.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");
              this.alert.content = "Your Client is Added into Client Master";
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    fetchSMData() {
      let new_data = {
        itemCode: "itemCode",
        allModuleId: this.ffExoprtDetail.allModuleId,
        actionType: this.actionType,
        clientId: this.ffExoprtDetail.clientId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchSplitMergeData_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          if (result.data.containerDetails.length > 0) {
            this.containerDetails = result.data.containerDetails;
          }
          if (result.data.clientMergeExecutionData.length > 0) {
            this.clientMergeExecutionData =
              result.data.clientMergeExecutionData;
          }

          this.$refs["my-modal-con"].show();
        })
        .catch((error) => {});
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // To change location of FCL/LCLexport ,CC, TPT, SalesExecution
    changeLocation() {
      let location = this.seriesNumber.split("/");
      if (this.objectItem.BranchCode) {
        let series = `${location[0]}/${location[1]}/${this.objectItem.BranchCode}/${location[3]}/${location[4]}`;

        const option = {
          categoryType: "hh",
          userId: this.userId,
          location: series,
          objectItem: this.objectItem,
          pickupId: this.objectItem.pickupId,
          allModuleId: this.allModuleId,
          type: location[1],
          newLocation: series.replaceAll("/", "_"),
          oldLocation: this.seriesNumber.replaceAll("/", "_"),
        };
        console.log(option);
        let options = {
          method: "POST",
          url: `${URL_BASE}/updateMISCLocation.php`,
          data: JSON.stringify(option),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { data } = result;
            this.getServicesData();
            this.getData();
            this.hideModalLoc();
             this.alert.content = data.MSG1;
             this.$refs["addPop"].open();
            
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        alert("please select loction!");
      }
    },
    getSalesSeries() {
      let ary = this.clientMergeExecutionData.filter((x) => {
        return x.allModuleId == this.ffExoprtDetail.mergeToAssignmentId;
      });
      if (ary.length > 0) {
        this.ffExoprtDetail.mergeToAssignmentNo = ary[0].mainSalesSeries;
      }
    },
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffExoprtDetail.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffExoprtDetail.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    // CommodityCallback(item) {
    //   this.ffExoprtDetail.commodityId = item.commodityId;
    //   this.ffExoprtDetail.commodityType = item.commodityType;
    //   this.ffExoprtDetail.itemDescription = item.itemDescription;
    // },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },

    jobTypeSelect(value, index) {
      let i = this.newJobType.indexOf(value);
      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
        this.newJobType.push(
          this.newJobType.splice(this.newJobType.indexOf("CC"), 1)[0]
        );
        this.newJobType.push(
          this.newJobType.splice(this.newJobType.indexOf("TPT"), 1)[0]
        );
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#FreghtContaner").DataTable();
      });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (
        this.ffExoprtDetail.clientId == "" &&
        this.ffExoprtDetail.clientType == "1"
      ) {
        $("#clientId").focus();
        this.clientIdError = "Select client name";
        validate_new = false;
      }

      // if (this.ffExoprtDetail.currencyType == "" && !this.showSegmentArray[0].isDisabled  && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")
      //   $("#currencyType").focus();
      //   this.currencyTypeError = "Select Currency Type";
      //   validate_new = false;
      // }

      // if (this.ffExoprtDetail.agreedByingOceanRate == ""  && !this.showSegmentArray[0].isDisabled && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")

      //   $("#agreedByingOceanRate").focus();
      //   this.agreedByingOceanRateError = "Select Agreed Buying Ocean Rate";
      //   validate_new = false;
      // }

      // if (this.ffExoprtDetail.agreedSellingOceanRate == ""  && !this.showSegmentArray[0].isDisabled && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")

      //   $("#agreedSellingOceanRate").focus();
      //   this.agreedSellingOceanRateError = "Select Agreed Selling Ocean Rate";
      //   validate_new = false;
      // }

      if (this.ffExoprtDetail.clientType == "") {
        $("#clientType").focus();
        this.clientTypeError = "Select client type";
        validate_new = false;
      }

      if (this.ffExoprtDetail.OtherServicType == "") {
        $("#OtherServicType").focus();
        this.OtherServicTypeError = "Select Service type";
        validate_new = false;
      }

      if (this.ffExoprtDetail.transportType == "") {
        $("#transportType").focus();
        this.transportTypeError = "Select Transport Type";
        validate_new = false;
      }
      if (this.ffExoprtDetail.shipmentType == "") {
        $("#transportType").focus();
        this.shipmentTypeError = "Select Shipment Type";
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.pickupLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#pickupLocationId").focus();
        this.pickupLocationIdError = "Select Pickup Location";
        validate_new = false;
      }
      if (
        this.ffExoprtDetail.stuffingLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#stuffingLocationId").focus();
        this.stuffingLocationIdError = "Select Factory  Location";
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.handoverLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#handoverLocationId").focus();
        this.handoverLocationIdError = "Select Handover Location";
        validate_new = false;
      }
      // if (
      //   this.ffExoprtDetail.transContainerTypeId == "" &&
      //   this.newJobType.indexOf("TPT") >= 0
      // ) {
      //   $("#transContainerTypeId").focus();
      //   this.transContainerTypeIdError = "Select Container Type";
      //   validate_new = false;
      // }

      if (
        this.newJobType.indexOf("CC") >= 0 ||
        (this.ffExoprtDetail.shipmentType == "1" &&
          this.newJobType.indexOf("FF") >= 0)
      ) {
        if (this.ffExoprtDetail.containerInfo == "") {
          $("#containerInfo").focus();
          this.containerInfoError = "Select FF Activity";
          validate_new = false;
        }

        if (this.ffExoprtDetail.shipmentType == "") {
          $("#shipmentType").focus();
          this.shipmentTypeError = "Select Shipping Type";
          validate_new = false;
        }

        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }
        // if (this.ffExoprtDetail.commodityId == "") {
        //   $("#commodityType").focus();
        //   this.commodityTypeError = "Select Commodity";
        //   validate_new = false;
        // }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (
          this.ffExoprtDetail.stuffingType == "" &&
          this.ffExoprtDetail.shipmentType == "1"
        ) {
          $("#stuffingType").focus();
          this.stuffingTypeError = "Select Stuffing Type";
          validate_new = false;
        }
        if (this.ffExoprtDetail.shippingId == "") {
          $("#shippingId").focus();
          this.shippingIdError = "Select Shipping Line";
          validate_new = false;
        }
        if (!this.ffExoprtDetail.PORlocationId) {
          $("#PORlocationId").focus();
          this.PORlocationIdError = "Select Place Of Receipt";
          validate_new = false;
        }
        if (!this.ffExoprtDetail.LPlocationId) {
          $("#LPlocationId").focus();
          this.LPlocationIdError = "Select Load Port";
          validate_new = false;
        }
        if (this.ffExoprtDetail.PODLocationId == "") {
          $("#PODLocationId").focus();
          this.PODLocationIdError = "Select Port Of Discharge";
          validate_new = false;
        }
        if (this.ffExoprtDetail.finalPlaceLocationId == "") {
          $("#finalPlaceLocationId").focus();
          this.finalPlaceLocationIdError = "Select Final Place Of Delivery";
          validate_new = false;
        }
      }

      if (
        this.ffExoprtDetail.shipmentType == "2" &&
        this.newJobType.indexOf("FF") >= 0
      ) {
        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (this.ffExoprtDetail.airportDeparture == "") {
          $("#airportDeparture").focus();
          this.airportDepartureError = "Select Airport Departure";
          validate_new = false;
        }

        if (this.ffExoprtDetail.airportDestination == "") {
          $("#airportDestination").focus();
          this.airportDestinationError = "Select Airport Departure";
          validate_new = false;
        }
        if (this.ffExoprtDetail.cargoReceived == "") {
          $("#cargoReceived").focus();
          this.cargoReceivedError = "Select Cargo Received";
          validate_new = false;
        }

        if (this.ffExoprtDetail.destinationModeAir == "") {
          $("#destinationModeAir").focus();
          this.destinationModeAirError = "Select Cargo Received";
          validate_new = false;
        }
      }

      if (this.ffExoprtDetail.clientType == "2") {
        if (this.ffExoprtDetail.newClientName == "") {
          $("#newClientName").focus();
          this.newClientNameError = "Enter Client Name";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }

        if (this.ffExoprtDetail.newClientPhoneNumber == "") {
          $("#newClientPhoneNumber").focus();
          this.newClientPhoneNumberError = "Enter Contact Number";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientEmail == "") {
          $("#newClientEmail").focus();
          this.newClientEmailError = "Enter Client Email";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientAddress == "") {
          $("#newClientAddress").focus();
          this.newClientAddressError = "Enter Client Address";
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
      }

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateMiscJob() {
      let validate_new = true;
      Object.keys(this.errormiscJobDetails).map((x, index) => {
        if (this.miscJobData[x] == "") {
          // alert("Pri");
          this.errormiscJobDetails[x] = this.arrayErrormiscJobDetails[0][x];
          validate_new = false;
        }
      });
      console.log("this.errormiscJobDetails=>", this.errormiscJobDetails);
      console.log(
        "this.arrayErrormiscJobDetails=>",
        this.arrayErrormiscJobDetails
      );
      if (validate_new == true) {
        this.miscvalidate = true;
      } else {
        this.miscvalidate = false;
      }
    },
    addMiscJob() {
      if (this.miscJobDetails.OtherServicType == "MISCELLANEOUS") {
        this.miscJobData["Jobcode"] = "MISC";
        this.miscJobDetails.Jobcode = "MISC";
      } else if (this.miscJobDetails.OtherServicType == "YARD") {
        this.miscJobData["Jobcode"] = "YARD";
        this.miscJobDetails.Jobcode = "YARD";
      } else if (this.miscJobDetails.OtherServicType == "IB") {
        this.miscJobData["Jobcode"] = "IB";
        this.miscJobDetails.Jobcode = "IB";
      }
      this.miscJobData["allModuleId"] = this.miscJobDetails.allModuleId;
      this.miscJobData["jobType"] = this.miscJobDetails.jobType;
      this.miscJobData["clientId"] = this.miscJobDetails.clientId;
      this.miscJobData["clientType"] = this.miscJobDetails.clientType;
      this.miscJobData["OtherServicType"] = this.miscJobDetails.OtherServicType;
      this.miscJobData["shipmentType"] = this.miscJobDetails.shipmentType;
      this.miscJobData["transportType"] = this.miscJobDetails.transportType;
      this.miscJobData["asignDeleted"] = this.miscJobDetails.asignDeleted;
      this.validateMiscJob();
      if (this.miscvalidate == false) return false;
      console.log(this.miscJobDetails);
      console.log(this.miscJobData);
      // return false;
      $("#addButtonLoader").css("display", "none");
      $("#loader").css("display", "block");
      if (this.miscvalidate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addMiscjobNew.php`,
          // url: `${URL_BASE}/Api_FFSeaExport/addMiscjob.php`,addMiscjobNew
          data: JSON.stringify(this.miscJobDetails),
          // data: JSON.stringify(this.miscJobDetails),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.status == 400 && data.error) {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content =
                  "REQUEST FAILED ..!! <Booking No Already Linked With Other Assignment";
                this.$refs["addPop22"].open();
              } else {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      }
    },
    addFFExport() {
      if (this.newJobType.length <= 0) {
        console.log(this.newJobType);
        this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop22"].open();
        return false;
      }

      if (
        !this.newJobType.includes("FF") &&
        this.ffExoprtDetail.clientType == "3"
      ) {
        console.log(this.newJobType.indexOf("FF"), "ty");
        this.alert.content =
          "Overseas Agent Execution must include Freight Forwarding..!   Please Select Freight to continue";
        this.$refs["addPop22"].open();
        return false;
      }
      if (this.ffExoprtDetail.shipmentType == "1") {
        this.ffExoprtDetail.airlineId = "0";
      } else {
        this.ffExoprtDetail.shippingId = "0";
      }

      if (this.multiContainer.length > 0) {
        let blankCon = this.multiContainer.filter((y) => {
          return (
            y.freghtContainersNo == undefined ||
            y.freghtContainersNo == "" ||
            y.freghtContainersNo == "0"
          );
        });

        if (blankCon.length > 0) {
          this.alert.content = "Please Enter all Container  Details";
          this.$refs["addPop22"].open();
          return false;
        }

        // if (
        //   this.multiContainer[0].freghtContainersNo == undefined ||
        //   this.multiContainer[0].freghtContainersNo == ""
        // ) {
        //   this.alert.content = "Please Enter Container Details";
        //   this.$refs["addPop22"].open();
        //   return false;
        // }
      }

      this.ffExoprtDetail.mainEnquiryId =
        this.$sessionsStorage.get("editMainEnqId");
      this.ffExoprtDetail["multiContainer"] = this.multiContainer;

      this.validateFFExport();

      if (this.ffExoprtDetail.clientIsActive == "2") {
        this.alert.content = "First add into client Master";
        this.$refs["addPop22"].open();
        return false;
      }
      if (this.ffExoprtDetail.isKYC == "No") {
        this.alert.content = "Complete the KYC";
        this.$refs["addPop22"].open();
        return false;
      }
      if (
        this.ffExoprtDetail.exporterClientId == "" &&
        this.ffExoprtDetail.clientType == "3" &&
        this.ffExoprtDetail.transportType == "Export"
      ) {
        this.alert.content = "Please Select Exporter";
        this.$refs["addPop22"].open();
        return false;
      }
      let newVal = [];
      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      if (
        this.newJobType.indexOf("TPT") >= 0 &&
        this.ffExoprtDetail.stuffingLocationId == ""
      ) {
        // let array = this.factoryDetail.filter(x => {
        //   return x.location == this.ffExoprtDetail.stuffingLocationId;
        // });
        // if (array.length == 0) {

        this.alert.content = "Please add Valid Factory Location ";
        this.$refs["addPop22"].open();

        return false;
        // }
      }

      if (
        this.newJobType.indexOf("CC") >= 0 &&
        this.ffExoprtDetail.shipmentType == "1" &&
        (this.ffExoprtDetail.PODLocationId == 0 ||
          this.ffExoprtDetail.PORlocationId == 0 ||
          this.ffExoprtDetail.finalPlaceLocationId == 0)
      ) {
        this.alert.content = "Please Select POR,Load Port,POD and FPOD  ";
        this.$refs["addPop22"].open();
        return false;
      }

      if (this.validate != false && this.ffExoprtDetail.jobType.length > 0) {
        this.alert.content =
          "Do you want  to send this Execution to Team? \n" +
          "Booking No :" +
          this.ffExoprtDetail.validBookingNo;
        this.$refs["sendExecution"].open();
      } else {
        console.log(this.validate, this.ffExoprtDetail.jobType.length);
        this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop22"].open();
        return false;
      }
    },

    onCloseAddFF() {
      this.$router.push({
        path: "/viewAllModuleDetails/viewAllModuleDetails",
      });
    },
    mergeSplitAssignment() {
      this.ffExoprtDetail.jobType = this.ShowJOB.split(",");
      this.ffExoprtDetail["previousAssignmentId"] =
        this.ffExoprtDetail.allModuleId;
      this.ffExoprtDetail["singleSelectContainer"] = this.singleSelectContainer;
      this.ffExoprtDetail["splitContainerType"] = this.splitContainerType;
      this.ffExoprtDetail["splitContainerTypeId"] = this.splitContainerTypeId;
      this.ffExoprtDetail["actionType"] = this.actionType;
      this.ffExoprtDetail["splitContainerTypeCount"] =
        this.splitContainerTypeCount;

      this.ffExoprtDetail.allModuleId = "";

      console.log(this.ffExoprtDetail);
      //return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addSplitMergeContainers_NewV3.php`,
        data: JSON.stringify(this.ffExoprtDetail),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.$refs["my-modal-con"].hide();
            this.$refs["my-modal-confirm"].hide();

            this.getData();
            // if (data.status == 400 && data.error) {
            //   this.alert.content =
            //     "REQUEST FAILED ..!! <Booking No Already Linked With Other Assignment";
            //   this.$refs["addPop22"].open();
            // } else {
            //   $("#loader").css("display", "none");
            //   $("#addButtonLoader").css("display", "block");
            //   this.alert.content = "Data Added Successfully";
            //   this.$refs["addPop"].open();
            // }
          }
        })
        .catch((error) => {});
    },

    sendExecutionTeam(type) {
      if (type != "cancel") {
        console.log(this.ffExoprtDetail);
        this.ffExoprtDetail.jobType = this.newJobType;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainSalesExec_NewV3_test.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.status == 400 && data.error) {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content =
                  "REQUEST FAILED ..!! <Booking No Already Linked With Other Assignment";
                this.$refs["addPop22"].open();
              } else {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      } else {
        this.ffExoprtDetail.jobType = [];
        this.newJobType = [];
      }
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getData(No) {
      let array = [];
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        exporterClientId: this.ffExoprtDetail.exporterClientId,
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
        allModuleId:
          this.$sessionsStorage.get("editSalesExId") != "" ||
          this.$sessionsStorage.get("editSalesExId") != undefined
            ? this.$sessionsStorage.get("editSalesExId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataSalesExe.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.airLineList.length > 0) {
              this.airLineList = data.airLineList;
            }
            if (data.coloaderData.length > 0) {
              this.getColoaderNameList = data.coloaderData;
            }
            if (data.ffseaType != "" && data.ffseaType != undefined) {
              this.ON_Type = data.ffseaType;
            }
            if (data.ffSlinePayId != "" && data.ffSlinePayId != undefined) {
              this.ffSlinePayId = data.ffSlinePayId;
            }
            if (data.ffSlinePayId != "" && data.ffSlinePayId != undefined) {
              this.$sessionsStorage.set("ffSlinePayId", data.ffSlinePayId);
            } else {
              this.$sessionsStorage.set("ffSlinePayId", "");
            }

            // alert(this.ON_Type);
            // alert(this.ffSlinePayId);
            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }
            if (data.UserData.length > 0) {
              this.ffExoprtDetail.BranchCode = data.UserData[0].BranchCode;
              this.userId = data.UserData[0].userId;
            }

            // if (data.CommodityData.length > 0) {
            //   this.getCommodityData = data.CommodityData;
            // } else {
            //   this.getCommodityData = [];
            // }

            if (data.execDoneData.length > 0) {
              // this.factoryDetail = data.factoryDetail;
              //  this.execDoneData = data.execDoneData;
              // if (
              //   this.execDoneData[0].jobType != "" &&
              //   this.execDoneData[0].jobType != null
              // ) {
              //   let doneArry = this.execDoneData[0].jobType.split(",");
              //   let F = doneArry.includes("FF");
              //   if (F == true) {
              //     this.showSegmentArray[0]["isDisabled"] = true;
              //   }
              //   let C = doneArry.includes("CC");
              //   if (C == true) {
              //     this.showSegmentArray[1]["isDisabled"] = true;
              //   }
              //   let T = doneArry.includes("TPT");
              //   if (T == true) {
              //     this.showSegmentArray[2]["isDisabled"] = true;
              //   }
              // }
            }

            if (data.clientdetailNew.length > 0) {
              this.getCLientData = data.clientdetailNew;
            } else {
              this.getCLientData = [];
            }
            if (data.clientdetailImpExp.length > 0) {
              this.getImporterExpo = data.clientdetailImpExp;
            } else {
              this.getImporterExpo = [];
            }
            if (data.factoryDetail.length > 0) {
              this.factoryDetail = data.factoryDetail;
            } else {
              this.factoryDetail = [];
            }

            this.getAlllocationListData = data.LocationDetailsFinal;

            this.getAlllocationHandover = data.LocationDetailsFinal;

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.AirPortLoadList = data.LocationDetailsFinal;
            this.AirIcdPOrtList = data.LocationDetailsFinal;

            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }
            let multiConType = [];
            let multiConId = [];
            let multiConNo = [];

            if (data.editAssignmentData.length > 0) {
              this.miscJobDetails.allModuleId =
                data.editAssignmentData[0].allModuleId;
              this.miscJobDetails.transportType =
                data.editAssignmentData[0].transportType;
                 this.miscJobDetails.OtherServicType =
                data.editAssignmentData[0].OtherServicType;
                // alert(data.editAssignmentData[0].OtherServicType);
              this.miscJobDetails.clientId =
                data.editAssignmentData[0].clientId;
              this.miscJobDetails.jobType = data.editAssignmentData[0].jobType;
              this.miscJobDetails.shipmentType =
                data.editAssignmentData[0].shipmentType;
              this.miscJobDetails.asignDeleted =
                data.editAssignmentData[0].asignDeleted;
                // this.miscJobDetails.mainSalesSeries =
                // data.editAssignmentData[0].mainSalesSeries;
                
            }

            if (data.editAssignmentData.length > 0 && No != "No") {
              this.seriesNumber = data.editAssignmentData[0].mainSalesSeries;
              this.allModuleId = data.editAssignmentData[0].allModuleId;
              if (data.editAssignmentData[0].engJobType) {
                this.jobTypeFromEnquiry =
                  data.editAssignmentData[0].engJobType.split(",");
              } else {
                this.jobTypeFromEnquiry = [];
              }
              this.factorySelectedAtEnquiry =
                data.editAssignmentData[0].stuffingLocationId;
              this.ffExoprtDetail.multipleContainerTypeId =
                data.editAssignmentData[0].multipleContainerTypeId;
              this.ShowJOB = data.editAssignmentData[0].jobType;
              this.mainSalesSeries = data.editAssignmentData[0].mainSalesSeries;
              if (this.ffExoprtDetail["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }

              Object.keys(data.editAssignmentData[0]).map((x) => {
                if (x == "jobType") {
                  array = data.editAssignmentData[0][x].split(",");
                  this.newJobType = data.editAssignmentData[0][x].split(",");
                } else if (x == "multipleContainerType") {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConType =
                      data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConType = [];
                  }
                } else if (x == "multipleContainerTypeId") {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConId = data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConId = [];
                  }
                } else if (x == "multiConNo") {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConNo = data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConNo = [];
                  }
                } else {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x] || "";
                }
              });
              this.multiContainer = [];
              if (multiConId.length > 0) {
                multiConId.map((p, index) => {
                  let obj = {
                    containerTypeID: p,
                    containerType: multiConType[index],
                    freghtContainersNo: multiConNo[index],
                  };

                  this.multiContainer.push(obj);
                });
              }

              this.ffExoprtDetail["jobType"] = [];

              if (
                this.$sessionsStorage.get("editSalesExId") == "" ||
                this.$sessionsStorage.get("editSalesExId") == null
              ) {
                if (
                  this.ffExoprtDetail.ccStatus == "0" ||
                  this.ffExoprtDetail.ccExpired == "1"
                ) {
                  let i = array.indexOf("CC");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }

                if (
                  this.newJobType.indexOf("FF") >= 0 &&
                  data.editAssignmentData[0].shippingId != ""
                ) {
                  this.ffExoprtDetail.shippingId = "";
                  this.ffExoprtDetail.shippingId =
                    data.editAssignmentData[0].approvedSLine;
                }

                if (
                  this.ffExoprtDetail.tptStatus == "0" ||
                  this.ffExoprtDetail.tptExpired == "1"
                ) {
                  let i = array.indexOf("TPT");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }
                if (
                  this.ffExoprtDetail.ffStatus == "0" ||
                  this.ffExoprtDetail.ffExpired == "1"
                ) {
                  let i = array.indexOf("FF");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }
              } else {
                this.ffExoprtDetail.shippingId =
                  data.editAssignmentData[0].shippingId;
                console.log(this.ffExoprtDetail.shippingId, "piuo");
              }
              this.ffExoprtDetail.airlineId =
                data.editAssignmentData[0].approvedAirLine;
              this.ffExoprtDetail.coLoaderId =
                data.editAssignmentData[0].approvedColoader;
              this.ffExoprtDetail.mainEnquirySeries =
                data.editAssignmentData[0].mainEnquirySeries;

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                if (i < 0) {
                  this.ffExoprtDetail.jobType[index] = false;
                  this.showSegmentArray[index]["isDisabled"] = true;
                }

                // if (array.length == 1) {
                //   // this.showSegmentArray[index]["isDisabled"] = true;
                // }
              });

              //  if( data.editAssignmentData[0].mainEnquirySeries){
              //     data.editAssignmentData[0].clientType =
              //  }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }
            if (
              No != "No" &&
              this.ffExoprtDetail.clientType == "3" &&
              this.ffExoprtDetail.shipmentType == "1" &&
              this.ffExoprtDetail.transportType == "Export"
            ) {
              //this.ffExoprtDetail.exporterClientId = "";
              //alert();
            }

            if (this.$sessionsStorage.get("isFFValid") == "false") {
              this.showSegmentArray[0]["isDisabled"] = true;
            }
            if (this.$sessionsStorage.get("isCCValid") == "false") {
              this.showSegmentArray[1]["isDisabled"] = true;
            }
            if (this.$sessionsStorage.get("isCCValid") == "false") {
              this.showSegmentArray[2]["isDisabled"] = true;
            }
            if (data.factoryDetail.length > 0) {
              let arryF = data.factoryDetail.filter((x) => {
                return x.pickupId == this.factorySelectedAtEnquiry;
              });
              if (arryF.length > 0) {
                console.log("Factory Exists");
                this.disableFactory = true;
              } else {
                this.ffExoprtDetail.stuffingLocationId = "";
                this.disableFactory = false;
              }
              // this.factoryDetail = data.factoryDetail;
              this.tempfactoryDetail = data.factoryDetail;
              this.getAlllocationListDataFactory = data.factoryDetail;
            }
            if (
              !this.ffExoprtDetail.finalPlaceLocationId ||
              this.ffExoprtDetail.finalPlaceLocationId == "0"
            ) {
              this.finalAllPlaceData = [];
            }
            if (
              !this.ffExoprtDetail.LPlocationId ||
              this.ffExoprtDetail.LPlocationId == "0"
            ) {
              this.PortLoadList = [];
            }
            if (
              !this.ffExoprtDetail.PODLocationId ||
              this.ffExoprtDetail.PODLocationId == "0"
            ) {
              this.PortDischargeList = [];
            }
            if (No != "No") {
              this.newJobType = [];
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },
    //  showExpInput() {
    //   if (this.ffExoprtDetail.exporterClientId != "") {
    //     let dummyExporter = this.getImporterExpo.filter(x => {
    //       return x.clientId == this.ffExoprtDetail.exporterClientId;
    //     });
    //     if (dummyExporter.length > 0) {
    //       if (dummyExporter[0].clientName == "Others") {
    //         this.openExpoInput = true;
    //       } else {
    //         this.openExpoInput = false;
    //       }
    //     }
    //   }
    //   if (this.ffExoprtDetail.importerClientId != "") {
    //     let dummyImporter = this.getImporterExpo.filter(x => {
    //       return x.clientId == this.ffExoprtDetail.importerClientId;
    //     });
    //     if (dummyImporter.length > 0) {
    //       if (dummyImporter[0].clientName == "Others") {
    //         this.openImpoInput = true;
    //       } else {
    //         this.openImpoInput = false;
    //       }
    //     }
    //   }
    // },

    previousFFView() {
      window.history.go(-1);
      // if (
      //   this.$sessionsStorage.get("editSalesExId") != "" &&
      //   this.$sessionsStorage.get("editSalesExId") != null &&
      //   this.$sessionsStorage.get("editSalesExId") != undefined
      // ) {
      //   this.$router.push({
      //     path: "/viewAllModuleDetails/viewAllModuleDetails"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/viewMainEnquiryDetails/viewMainEnquiryDetails"
      //   });
      // }
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "FREIGHT FORWARDING (FF)",
          flex: "30",
          isDisabled: false,
        },
        {
          value: "CC",
          show: "CUSTOM CLEARANCE (CC)",
          flex: "30",
          isDisabled: false,
        },
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "30",
          isDisabled: false,
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// miscSalesExecution.vue?b1d47b70